import { CheckCircle2 } from "lucide-react";

const points = [
  { title: "Blockchain-Analyse:", text: "Tracking von BTC, ETH und Stablecoins durch professionelle Analysetools." },
  { title: "Rechtshilfe:", text: "Erwirkung von Kontosperren (Freezing Orders) bei Krypto-Börsen weltweit." },
  { title: "Behördenkommunikation:", text: "Professionelle Aufbereitung der Beweislast für die Staatsanwaltschaften." },
];

export function Strategies() {
  return (
    <section className="py-16 md:py-24">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-2 lg:items-center">
        <div>
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">
            Recovery-Strategien bei Krypto-Scams
          </h2>
          <p className="mt-4 text-muted-foreground">
            Entgegen der landläufigen Meinung ist Blockchain-Technologie nicht
            völlig anonym. Durch spezialisierte Forensik und rechtliche Hebel
            lassen sich Transaktionspfade bis zu regulierten Börsen zurückverfolgen.
          </p>
          <ul className="mt-8 space-y-4">
            {points.map((p) => (
              <li key={p.title} className="flex gap-3">
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
                <p className="text-sm text-foreground">
                  <strong className="font-semibold">{p.title}</strong> {p.text}
                </p>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-2xl bg-navy p-8 text-primary-foreground shadow-[var(--shadow-elegant)] md:p-10">
          <p className="text-xs font-semibold uppercase tracking-widest text-gold">
            Die Veritas-Garantie
          </p>
          <h3 className="mt-3 text-2xl font-bold leading-tight md:text-3xl">
            Keine leeren Versprechungen. Nur Fakten.
          </h3>
          <p className="mt-4 text-sm text-white/75">
            Wir übernehmen nur Mandate, bei denen wir reale Erfolgschancen sehen.
            Unsere Reputation basiert auf Transparenz und juristischer Präzision.
          </p>
          <div className="mt-8 space-y-3 border-t border-white/10 pt-6 text-sm">
            <div className="flex items-center justify-between">
              <span className="text-white/70">Mandantenbetreuung</span>
              <span className="font-semibold text-gold">Persönlich</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-white/70">Erfolgsquote (geprüft)</span>
              <span className="font-semibold text-gold">Überdurchschnittlich</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}